import { Box, Button, Group, Modal, Stack } from "@mantine/core"
import type { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import classes from "./settings-modal.module.css"

type Props = {
  opened: boolean
  onClose: () => void
  title: ReactNode
  onSubmit: (e?: React.FormEvent<HTMLFormElement>) => void
  submitLabel: string
  submitting?: boolean
  size?: number | string
  children: ReactNode
}

/** Shared shell of the /settings create/edit modals (canvas Ord_Settings). */
export function SettingsModal({
  opened,
  onClose,
  title,
  onSubmit,
  submitLabel,
  submitting,
  size = 600,
  children,
}: Props) {
  const { t } = useTranslation("settings")
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={title}
      size={size}
      radius="lg"
      classNames={{ title: classes.title, close: classes.close }}
    >
      <Box component="form" onSubmit={onSubmit}>
        <Stack gap="sm">{children}</Stack>
        <Group justify="flex-end" className={classes.footer}>
          <Button variant="default" onClick={onClose}>
            {t("common.cancel")}
          </Button>
          <Button type="submit" color="dark" loading={submitting}>
            {submitLabel}
          </Button>
        </Group>
      </Box>
    </Modal>
  )
}
